import { object, string } from 'yup'

import { project } from './shared/project'
import { filename } from './shared/filename'
import { safify } from 'components/Wizards/schemas/utils/safify'

import { DesignChannel } from 'components/NewFileModal/Types'
import { MultiStepSchema } from './Types'

export const RecommendMoreContentSchema = {
  meta: {
    type: 'recommend_more_content',
    channel: DesignChannel.Post,
    title: 'Recommend More Content',
    previewUrl: '',
  },
  steps: [
    object({
      post_amount: string()
        .required()
        .oneOf(['5', '10', '15'])
        .default('5')
        .meta({ label: 'How many more posts would you like?', autoFill: true })
        .transform(safify),
      project: project.meta({
        label: 'Name your campaign and select a location',
        placeholder: 'Name your campaign...',
      }),
      filename,
    }).meta({
      title: 'Number of Posts',
      submitLabel: 'Generate Posts',
      previousLabel: 'Cancel',
    }),
    object({}).meta({
      title: 'Review',
      submitLabel: 'Schedule All Posts',
      previousLabel: 'Back',
    }),
    object({}).meta({
      title: 'Schedule',
      submitLabel: 'Schedule Posts',
      previousLabel: 'Review',
    }),
  ],
} as MultiStepSchema
